import { render, staticRenderFns } from "./ConferenceSection.vue?vue&type=template&id=8af812b4&"
import script from "./ConferenceSection.vue?vue&type=script&lang=js&"
export * from "./ConferenceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports